const LOCAL_DATE_KEY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;

export function toLocalDateKey(value: Date): string {
  return [
    value.getFullYear(),
    String(value.getMonth() + 1).padStart(2, "0"),
    String(value.getDate()).padStart(2, "0"),
  ].join("-");
}

export function parseLocalDateKey(value: string): Date | null {
  const match = LOCAL_DATE_KEY_PATTERN.exec(value);
  if (!match) return null;

  const date = new Date(
    Number(match[1]),
    Number(match[2]) - 1,
    Number(match[3]),
  );
  return toLocalDateKey(date) === value ? date : null;
}

export function incrementLocalDateKey(value: string): string | null {
  const date = parseLocalDateKey(value);
  if (!date) return null;
  date.setDate(date.getDate() + 1);
  return toLocalDateKey(date);
}

export function isSameLocalDay(left: Date, right: Date): boolean {
  return toLocalDateKey(left) === toLocalDateKey(right);
}
